import * as axios from 'axios';

function getAll() {
	const data = {};

	const url = `/admin/locations/all`;
	return (
		axios
			.get(url, data)
			// get data
			.then((x) => x.data)
			// add url field
			.then((x) => {
				if (x.status == 'error') {
					return Promise.reject(x);
				}
				return x;
			})
	);
}

function getLocation(uid) {
	const data = {};
	const url = `/admin/locations/detail/${uid}`;
	return axios
		.get(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function getLocationDocuments(data) {
	const url = `/admin/locations/documents`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function sendInvoice(data) {
	const url = `/admin/locations/send-invoice`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function updateInvoiceInfo(data) {
	const url = `/admin/locations/update-invoice-info`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function searchFull(data) {
	const url = `/admin/locations/search-full`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function createPdf(data) {
	const url = `/admin/locations/create-pdf`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function updateLocationBase(data) {
	const url = `/admin/locations/base`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function updateLocation(data) {
	const url = `/admin/locations/account`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function removeLocation(data) {
	const url = `/admin/locations/remove`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function updateProduct(data) {
	const url = `/admin/locations/update-product`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function addBilling(data) {
	const url = `/admin/locations/add-billing`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function cancelInvoice(data) {
	const url = `/admin/locations/cancel-invoice`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function updateStaffAccess(data) {
	const url = `/admin/locations/update-staff-access`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

export {
	getAll,
	getLocation,
	sendInvoice,
	updateLocation,
	updateInvoiceInfo,
	removeLocation,
	updateLocationBase,
	getLocationDocuments,
	createPdf,
	updateProduct,
	cancelInvoice,
	searchFull,
	addBilling,
	updateStaffAccess,
};
